export const templateSizesSelector = state => state.entities.templateSizes;